import { IEquipment } from '@/pages/Equipment/equipment.types.ts'
import { useRecoilValue } from 'recoil'
import equipmentAtom from '@/pages/Equipment/atoms/equipment.atom.ts'
import { useMemo } from 'react'
import equipmentUtils from '../equipment.utils'

const useSameAddressEquipment = (e: Pick<IEquipment, 'location' | 'id'>): IEquipment[] => {
  const equipments = useRecoilValue(equipmentAtom).items

  return useMemo(() => {
    if (!e) return []

    return equipments.filter((it) => e.id !== it.id && equipmentUtils.isEquipmentAddressEqual(it.location, e.location))
  }, [equipments, e])
}

export default useSameAddressEquipment
